import React, { useState, useEffect } from 'react';

const AddressSearch = ({ onAddressSelect, postalCode = null }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [userChangedSearchTerm, setUserChangedSearchTerm] = useState(false);

  useEffect(() => {
    if (postalCode && !userChangedSearchTerm && !isNaN(postalCode)) {
      setSearchTerm(postalCode);
      getSearchSuggestions(postalCode);
    }
  }, [postalCode, userChangedSearchTerm]);


  const handleSearchChange = async (e) => {
    const term = e.target.value;
    setUserChangedSearchTerm(true);

    setSearchTerm(term);

    if (selectedAddress !== null) {
      setSelectedAddress(null);
    }

    getSearchSuggestions(term);
  };

  const getSearchSuggestions = (term) => {
    if (term.length < 3) {
      setSearchResults([]);
      return;
    }

    // Make a request to Nominatim API to fetch search results
    try {
      let query = '';
      // if term is numeric, search for postal code
      if (!isNaN(term)) {
        query = `https://nominatim.openstreetmap.org/search?postalcode=${term}&format=json&countrycodes=AT,DE,CH&layer=address`
      } else {
        query = `https://nominatim.openstreetmap.org/search?q=${e.target.value}&format=json&countrycodes=AT,DE,CH&layer=address`
      }

      fetch(query)
        .then(response => response.json())
        .then(data => {
          const relevantResults = data.filter(result =>
            result.class === 'boundary'
            || (result.class === 'place' && result.type === 'postcode')
            || (result.class === 'place' && result.type === 'village')
            || (result.class === 'place' && result.type === 'suburb')
            || (result.class === 'place' && result.type === 'quarter')
            || (result.class === 'place' && result.type === 'hamlet')
          );
          setSearchResults(relevantResults);

          // console.log(data);
        });
    } catch (error) {
      console.error('Error fetching search results:', error);
    }
  };

  const handleAddressSelect = (address) => {
    setUserChangedSearchTerm(true);
    setSearchTerm(address.display_name);
    setSelectedAddress(address);
    setSearchResults([]);
    onAddressSelect(address);
  };

  return (
    <div className='vendor-address-search'>
      <input
        type="text"
        className="vendor-address-search-input"
        value={searchTerm}
        onChange={handleSearchChange}
        placeholder="Suche nach Postleitzahl/Ort"
      />
      {searchResults.length > 0 && searchTerm.length >= 3 && selectedAddress === null && (
        <ul>
          {searchResults.map((result) => (
            <li key={result.place_id} onClick={() => handleAddressSelect(result)}>
              {result.display_name}
            </li>
          ))}
        </ul>
      )}
      {navigator.geolocation && (
        <button className="geolocate-button" onClick={() => {
          navigator.geolocation.getCurrentPosition((position) => {
            const address = {
              lat: position.coords.latitude,
              lon: position.coords.longitude,
              display_name: "Ihr Standort"
            };
            handleAddressSelect(address);
          }, (error) => {
            console.error('Error getting geolocation:', error);
            alert('Fehler beim Abrufen Ihres Standorts. Bitte erlauben Sie den Zugriff auf Ihren Standort oder geben Sie eine Adresse ein.');
          });
        }}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#1f1f1f"><path d="M440-42v-80q-125-14-214.5-103.5T122-440H42v-80h80q14-125 103.5-214.5T440-838v-80h80v80q125 14 214.5 103.5T838-520h80v80h-80q-14 125-103.5 214.5T520-122v80h-80Zm238-240q82-82 82-198t-82-198q-82-82-198-82t-198 82q-82 82-82 198t82 198q82 82 198 82t198-82Zm-311-85q-47-47-47-113t47-113q47-47 113-47t113 47q47 47 47 113t-47 113q-47 47-113 47t-113-47Zm169.5-56.5Q560-447 560-480t-23.5-56.5Q513-560 480-560t-56.5 23.5Q400-513 400-480t23.5 56.5Q447-400 480-400t56.5-23.5ZM480-480Z" /></svg>
        </button>
      )}
    </div>
  );
};

export default AddressSearch;
